import { rem } from 'polished';
import { css } from 'styled-components';

function getTextStyles(fontWeight, fontSize, lineHeight, spacing) {
  return css`
    font-weight: ${fontWeight};
    font-size: ${rem(fontSize)};
    line-height: ${lineHeight};
    letter-spacing: ${spacing};
    margin: 0;
  `;
}

export const scale1 = getTextStyles(600, '80px', 1, 0);
export const scale2 = getTextStyles(600, '52px', 1.12, 0);
export const scale3 = getTextStyles(600, '42px', 1.24, 0);
export const scale4 = getTextStyles(600, '36px', 1.28, 0);

export const titleXXL = getTextStyles(500, '30px', 1.34, 0);
export const titleXL = getTextStyles(500, '26px', 1.23, 0);
export const titleLG = getTextStyles(500, '24px', 1.25, 0);
export const titleMD = getTextStyles(500, '22px', 1.28, 0);
export const titleSM = getTextStyles(500, '20px', 1.3, 0);
export const titleXS = getTextStyles(500, '18px', 1.33, 0);

export const bodyLead = getTextStyles(400, '18px', 1.44, 0);
export const bodyLeadMedium = getTextStyles(500, '18px', 1.44, 0);
export const bodyLeadBold = getTextStyles(600, '18px', 1.44, 0);

export const body = getTextStyles(400, '16px', 1.5, 0);
export const bodyMedium = getTextStyles(500, '16px', 1.5, 0);
export const bodyBold = getTextStyles(600, '16px', 1.5, 0);

export const bodySpecial = getTextStyles(400, '15px', 1.2, '-0.2px');

export const bodySM = getTextStyles(400, '14px', 1.57, 0);
export const bodySMMedium = getTextStyles(500, '14px', 1.29, 0);
export const bodySMBold = getTextStyles(600, '14px', 1.29, 0);

export const bodyXS = getTextStyles(400, '12px', 1.16, 0);

export const bodyTable = getTextStyles(400, '14px', 1.29, '-0.2px');
export const bodyTableMedium = getTextStyles(500, '14px', 1.29, '-0.2px');
export const bodyTableBold = getTextStyles(600, '14px', 1.29, '-0.2px');

export const bodyCaption = getTextStyles(400, '13px', 1.23, 0);

export const subHead = getTextStyles(500, '13px', 1.23, '0.7px');
export const subHeadSM = getTextStyles(600, '11px', 1.27, 0);
export const subHeadXS = getTextStyles(600, '10px', 1.4, '1px');

export const mono = css`
  font-family: var(--typography-fontMono);
`;
